import * as Yup from 'yup';

export const validationPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .min(8, 'Minimum van 8 verplicht')
        .matches(/([0-9])/, 'Minimaal 1 cijfer is verplicht')
        .matches(/([A-Z])/, 'Minimaal 1 hoofdletter is verplicht')
        .required('Verplicht'),
});
